import videojs from 'video.js';
import './add-like.js';
import './bubbles.js';

const Component = videojs.getComponent('Component');

class Likes extends Component {
    constructor(player, options) {
        super(player, options);
        this.addClass('vjs-likes__container');
        this.addChild('Bubbles', options);
        this.addChild('AddLike', options);
    }
}

Component.registerComponent('Likes', Likes);
